import { Modal } from "bootstrap";

export default class AddPostModal extends HTMLDivElement {

    connectedCallback() {

        this.addEventListener("shown.bs.modal", this.handleModalShown);

        if (!window.preventBoostrapBlockingFocusFix) {
            document.addEventListener("focusin", this.preventBoostrapBlockingFocus);
            window.preventBoostrapBlockingFocusFix = true;
        }
    }

    disconnectedCallback() {

        this.removeEventListener("shown.bs.modal", this.handleModalShown);

        document.removeEventListener("focusin", this.preventBoostrapBlockingFocus);

    }

    handleModalShown = () => {
        this.querySelector("[is=\"tiny-mce\"]").setAttribute("data-mode", "load");
    }

    // Bootstrap modal dialog prevents focus for elements outside the dialog.
    // This is a simple fix for that.
    preventBoostrapBlockingFocus = (e) => {

        const tinyDialog = e.target.closest(".tox-dialog");
        if (tinyDialog != null) {
            e.stopImmediatePropagation();
        }

    }

    get postId() {
        return this.querySelector("[name=\"FormViewModel.Id\"]");
    }

}

customElements.define('add-post-modal', AddPostModal, { extends: 'div' });